import { useEffect, useState, useCallback } from "react";

/**
 * Hook para controlar a régua do mapa.
 * @param {Map|null} mapInstance Instância do mapa da @inlog/inlog-maps/lib
 * @returns { enabled, setEnabled, toggleRuler }
 */
export const useRuler = (mapInstance) => {
  const [rulerEnabled, setRulerEnabled] = useState(false);

  const toggleRuler = useCallback(() => {
    setRulerEnabled((prev) => !prev);
  }, []);

  useEffect(() => {
    if (!mapInstance) return;
    if (rulerEnabled) {
      mapInstance.createRuler?.();
    } else {
      mapInstance.removeRuler?.();
    }
    return () => {
      mapInstance.removeRuler?.();
    };
  }, [mapInstance, rulerEnabled]);

  return {
    rulerEnabled,
    setRulerEnabled,
    toggleRuler,
  };
};
